var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFlame(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 32,
    viewBox: "0 0 44 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.66667 0.5H39.3333C41.6147 0.5 43.5 2.43605 43.5 4.86957V27.1304C43.5 29.5639 41.6147 31.5 39.3333 31.5H4.66667C2.38532 31.5 0.5 29.5639 0.5 27.1304V4.86957C0.5 2.43605 2.38532 0.5 4.66667 0.5Z",
    fill: "white",
    stroke: "#D9D9D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.7519 25.9552H24.2643C29.747 25.9552 34.116 21.3828 34.2874 15.7344V15.6447C34.2017 9.90675 29.747 5.24462 24.2643 5.33428H20.3236C15.098 5.51359 10.9859 10.1757 11.1573 15.7344C11.1573 21.2931 15.4406 25.8655 20.7519 25.9552ZM12.8707 15.6447C12.8707 10.9826 16.5543 7.12737 21.009 7.12737C25.4637 7.12737 29.1474 10.9826 29.1474 15.6447C29.1474 20.3069 25.4637 24.1621 21.009 24.1621C16.5543 24.1621 12.8707 20.3069 12.8707 15.6447ZM22.294 21.3827V9.99638C25.2923 10.8033 27.1771 13.9413 26.406 17.0792C25.892 19.231 24.35 20.8448 22.294 21.3827ZM15.6976 14.2103C14.9266 17.3482 16.7256 20.5758 19.724 21.3827V9.99638C17.7537 10.5343 16.2116 12.1481 15.6976 14.2103Z",
    fill: "#0079BE"
  })));
}

export default SvgFlame;